<template lang="pug">
.feature-card
  img.feature-card__icon(:src="icon" :alt="title")
  h3.feature-card__title {{ title }}
  p.feature-card__description {{ description }}
</template>

<script>
export default {
  name: 'FeatureCard',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.feature-card {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
  padding: 28px;
}

.feature-card__icon {
  display: block;
  flex-shrink: 0;
  height: 68px;
  width: 68px;
}

.feature-card__title {
  color: #0b6882;
  font-family: 'Plus Jakarta Sans', 'Ubuntu', sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  margin: 0;
}

.feature-card__description {
  color: #727272;
  font-family: 'Ubuntu', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
}
</style>
